import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/channel-welcome-messages'

export async function getList(payload) {
    return request(`${api.getList.url}?${stringify(payload)}`)
}

export async function editUser(payload = {}) {
    return request(api.editUser.url, {
        method: api.editUser.type,
        body: payload.body,
    })
}
